'use client';

import { createContext, useContext } from 'react';

export interface ConfirmOptions { title?: string; description: string; tone?: 'danger' | 'warning' | 'neutral'; confirmLabel?: string; cancelLabel?: string; }
export const ConfirmContext = createContext<((options: string | ConfirmOptions) => Promise<boolean>) | null>(null);
export function useConfirm() {
  const confirm = useContext(ConfirmContext);
  if (!confirm) throw new Error('useConfirm requires ConfirmProvider');
  return confirm;
}
